<div class="details">
    <div class="game-banner">
      <img
        class="game-banner-img"
        src="{{ game.background_image }}"
        alt="background image"
      />
    </div>
    <div class="game-content">
      <div class="details-wrapper">
        <div class="game-header">
          <h1 class="game-header-title">{{ game.name }}</h1>
          <h2 class="game-header-release-date">
            Release: {{ game.released | date }}
          </h2>
          <p class="game-header-genres">
            <span *ngFor="let genre of game.genres; let last = last"
            >{{ genre.name }}<span *ngIf="!last">, </span></span
          >
          </p>
          <div class="game-gauge">
            <mwl-gauge
              class="two"
              [max]="100"
              [dialStartAngle]="180"
              [dialEndAngle]="0"
              [value]="gameRating"
              [animated]="true"
              [color]="getColor"
              [animationDuration]="2"
            >
            </mwl-gauge>
            <a
              class="game-gauge-label"
              target="_blank"
              href="{{ game.metacritic_url }}"
              >Metacritic</a
            >
          </div>
        </div>
        <app-game-tabs [game]="game"></app-game-tabs>
      </div>
    </div>
  </div>
  